import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

ClassNameGenerator.configure((componentName: string) => componentName.replace('Mui', 'V5')); // load as early as possible this code in a js file
import '../../utils/MuiClassNameSetup';

import productImageModule from '@rakutenfrance/product-image';
import { getServerSidePropsLoader, regroupModuleReducers } from '@rakutenfrance/redux-apollo-helper';

import React from 'react';
import { renderReact } from '../../fragmentHelper/renderReactCustom';

import { ReduxApolloFragmentWrapperChildren } from '../../fragmentHelper/Wrapper';
import { GetServerSidePropsHypernovaWatchContext, PagePropsType } from '../../types';
import '@rakutenfrance/product-image/build/style.global.css';
import { configService as configurationService } from '@rakutenfrance/config-service';
import Box from '@mui/material/Box';
import { tolgeeModule } from '@rakutenfrance/tolgee-provider';

export { productImageModule };

const { ProductImageContainer } = productImageModule.containers;
declare global {
  interface Window {
    hypernovaProductImageLazyInit: any;
  }
}

const StyleTag: React.FC = () => {
  return (
    <style
      id="product-image-styles"
      dangerouslySetInnerHTML={{
        __html: `
        @media (min-width: 1440px) and (max-width: 1920px) {
          .sideBanner:not([style*='display: none']) ~ .image-wrapper,
          .sideBanner:not([style*='display: none']) ~ .image-container,
          .sideBanner:not([style*='display: none']) ~ .desktop-image-container,
          body:has(.sideBanner:not([style*='display: none'])) .image-wrapper,
          body:has(.sideBanner:not([style*='display: none'])) .desktop-image-container,
          body:has(.sideBanner:not([style*='display: none'])) .image-container {
            width: 456px !important;
            height: 400px !important;
            max-width: 456px !important;
            max-height: 400px !important;
          }

          .sideBanner:not([style*='display: none']) ~ .product-image,
          .sideBanner:not([style*='display: none']) ~ .ssr-image-container,
          .sideBanner:not([style*='display: none']) ~ .ssr-image-loader,
          .sideBanner:not([style*='display: none']) ~ .ssr-image-desktop-container,
          body:has(.sideBanner:not([style*='display: none'])) .product-image,
          body:has(.sideBanner:not([style*='display: none'])) .ssr-image-container,
          body:has(.sideBanner:not([style*='display: none'])) .ssr-image-loader,
          body:has(.sideBanner:not([style*='display: none'])) .ssr-image-desktop-container {
            width: 400px !important;
            height: 400px !important;
          }
        }
        `,
      }}
    />
  );
};

const modules = [productImageModule, tolgeeModule] as any[];
const reducers = regroupModuleReducers(modules);

const WrappedProductImage: React.FC<PagePropsType> = ({ initialApolloState, initialReduxState }) => {
  return (
    <ReduxApolloFragmentWrapperChildren
      initialApolloState={initialApolloState}
      initialReduxState={initialReduxState}
      reducers={reducers}
    >
      <StyleTag />
      <Box>
        <ProductImageContainer />
      </Box>
    </ReduxApolloFragmentWrapperChildren>
  );
};

export const serverCanCache = true;

export const renderFunction = renderReact('ProductImage', WrappedProductImage);

if (typeof window !== 'undefined') {
  window.hypernovaProductImageLazyInit = (): void => {
    renderReact('ProductImage', WrappedProductImage);
  };
}


export const getServerSideProps = async (watchContext: GetServerSidePropsHypernovaWatchContext) => {
  const baseUrl = "";
  const wsBaseUrl = configurationService.get().gatewayUrl;

  const preloadedConfig = {
    ProductImage: {
      productId: watchContext.jobData?.productId !== undefined ? watchContext.jobData.productId : null,
      wsBaseUrl,
      galleryIdBaseUrl: process.env.GALLERY_ID_URL,
      galleryDataGatewayUrl: process.env.GALLERY_DATA_URL,
    },
  };

  const graphQlVariables = {};
  const graphQlQuery = '';
  const { initialReduxState, initialApolloState } = await getServerSidePropsLoader(
    watchContext,
    modules,
    baseUrl,
    preloadedConfig,
    graphQlQuery,
    graphQlVariables
  );

  // const customStatusCode = initialReduxState?.productImage?.customStatusCode;

  return {
    props: {
      initialReduxState,
      initialApolloState,
      // customStatusCode,
    },
  };
};
